class ThemeHeader extends HTMLElement {
  constructor() {
    super();

    const element = this;

    const threshold = 800;

    window.addEventListener("scroll", Theme.Helpers.debounce(scroller, 100));

    let last_position = 0;
    let animating = false;

    function scroller() {
      if (animating) {
        return;
      }

      const current_position = window.scrollY || window.pageYOffset;

      if (current_position <= 20) {
        element.classList.remove("state--fixed");
        element.classList.remove("state--active");
        element.style.transition = "none";
      }

      if (current_position >= threshold && current_position > last_position) {
        element.classList.add("state--fixed");
      }

      if (current_position >= threshold && current_position < last_position) {
        animating = true;

        element.style.transition = "transform 200ms ease-in-out";
        element.classList.add("state--active");

        setTimeout(function () {
          animating = false;
        }, 200);
      }

      last_position = current_position;
    }
  }
}

customElements.define("theme-header", ThemeHeader);